<div fxLayout="column" fxLayoutGap="8px">
  @if (standalone) {
    <etoh-back-button
      [route]="['/features/samples/edit', samplesId?.[0]]"
      >Back to the sample</etoh-back-button
      >
    }

    <nz-radio-group [formControl]="selectedTemplate">
      @for (format of formatOptions; track format; let i = $index) {
        <label
          nz-radio-button
          [nzValue]="format.name"
          >
          {{ format.name }}
        </label>
      }
    </nz-radio-group>

    <etoh-pdf-user-generator
      [data$]="data$"
      [locale]="userOfficeService.userOffice$.value?.locale"
      [formats]="formats"
      [pdfName]="pdfName"
      url="samples"
      >
      @if (selectedTemplate.value) {
        @for (sample of (data$ | async)?.samples; track sample) {
          <etoh-sample-label-pdf-content
            [datas]="sample"
            [locale]="userOfficeService.userOffice$.value?.locale"
            [templateName]="selectedTemplate.value"
          ></etoh-sample-label-pdf-content>
        }
      }
    </etoh-pdf-user-generator>
  </div>
